import { Text } from '@/ui-components/atoms/Text/Text';
import { ChannelLink, listenLabel } from '@/ui-components/molecules/BroadcastGrid/broadcastRows';
import styles from './sportsScheduleStrip.module.scss';

export interface SportsDriverChannel {
    name: string;
    channel: string | number;
    href?: string;
}

export interface SportsDriverChannelsProps {
    title?: string;
    channels: SportsDriverChannel[];
}

export function SportsDriverChannels({ title = 'Driver Channels', channels }: SportsDriverChannelsProps) {
    return (
        <div className={styles.driverChannels}>
            <div className={styles.driverPanel}>
                <Text tag="p" className={styles.driverTitle}>
                    {title}
                </Text>
                <ul className={styles.driverList}>
                    {channels.map((channel) => (
                        <li key={channel.name} className={styles.driverItem}>
                            <Text tag="span" className={styles.name}>
                                {channel.name}
                            </Text>
                            <ChannelLink
                                channel={channel.channel}
                                deepLink={channel.href}
                                ariaLabel={listenLabel(channel.name, channel.channel)}
                                staticChip
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
